import React from "react";
import { Form, Input, Modal, Select } from "antd";

export const TagFormModal = ({
  open,
  title,
  okText,
  onCancel,
  onOk,
  form,
  categoryOptions,
}) => {
  return (
    <Modal
      title={title}
      open={open}
      onCancel={onCancel}
      onOk={onOk}
      okText={okText}
    >
      <Form layout="vertical" form={form}>
        <Form.Item
          label="Slug"
          name="slug"
          rules={[
            { required: true, message: "Slug оруулна уу" },
            { pattern: /^\S+$/, message: "Slug-д зай орохгүй" },
          ]}
        >
          <Input placeholder="Ж: spicy" />
        </Form.Item>
        <Form.Item label="Label" name="label">
          <Input placeholder="Name" />
        </Form.Item>
        <Form.Item label="Ангилал" name="category">
          <Select options={categoryOptions} placeholder="Ангилал сонгоно уу" allowClear />
        </Form.Item>
        <Form.Item label="Өнгө" name="color">
          <Input type="color" className="color-input" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export const DeleteTagModal = ({ open, tag, onCancel, onConfirm }) => {
  return (
    <Modal
      title="Tag устгах?"
      open={open}
      onCancel={onCancel}
      onOk={onConfirm}
      okText="Устгах"
      okType="danger"
      cancelText="Буцах"
    >
      <p>
        {tag?.slug ? `"${tag.slug}"` : "Энэ tag"}-г устгах уу? Устгах үйлдлийг
        буцаах боломжгүй.
      </p>
    </Modal>
  );
};
